import { takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';

import {
  updateMatchesStarted,
  updateMatchesEnded
} from 'actions/index';

import {
  fetchMatches,
  updateMatches,
  changeMatchesApprovedStatus,
  updateMatchesWith
} from 'api/index';

import {
  UPDATE_MATCHES_REQUESTED,
  UPDATE_MATCHES_WITH,
  TOGGLE_MATCH_APPROVED
} from 'constants/index';

const sleep = ms => () => new Promise(resolve => setTimeout(resolve, ms));

import {MATCHES_NS} from 'constants/index';

import {matchAction} from 'utils/helpers';

import {actionCreators} from 'utils/resourcerizer';

const {initialize, insert, updateOne} = actionCreators(MATCHES_NS);

export default function() {
  return [
    takeLatest(matchAction(initialize()), function*() {
      let matches;

      let stale = true;
      while(stale) {
        try {
          matches = yield call(fetchMatches);
          stale = false;
        } catch (err) {
          if(err.response.status === 503) {
            yield call(sleep(1000));
          }else{
            console.warn(err);
            return;
          }
        }
      }

      yield put(insert(matches));

    }),

    takeLatest(TOGGLE_MATCH_APPROVED, function* (action) {
      const { payload: { id } } = action;

      try {
        const data = yield call(changeMatchesApprovedStatus, id);
        yield put(updateOne(id,data));
      } catch (err) {
        console.warn(err);
      }
    }),

    takeLatest(UPDATE_MATCHES_REQUESTED, function* () {

      try {
        yield call(updateMatches);
      } catch(err) {
        if(err.response.status !== 503) {
          console.warn(err);
          return;
        }
      }

      yield put(updateMatchesStarted());
      yield call(sleep(1000));
      yield put(initialize());

      yield put(updateMatchesEnded());
    }),
    takeLatest(UPDATE_MATCHES_WITH, function* (action) {
      const { payload: {candidateIds, vacancyIds} } = action;

      try {
        yield call(updateMatchesWith, {candidateIds, vacancyIds});
      } catch(err) {
        if(!err.response || err.response.status !== 503) {
          console.warn(err);
          return;
        }
      }

      yield put(updateMatchesStarted());
      yield call(sleep(1000));
      yield put(initialize());

      yield put(updateMatchesEnded());
    })
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/matches.js